:host {
  overflow: hidden;
}

.wrapper {
  flex-direction: column;

  .loader {
    display: none;
  }

  &.is-loading {
    .loader {
      display: block;
    }

    .panel-content {
      display: none;
    }

    .header {
      display: none;
    }
  }
}

.side-menu-select {
  height: 31px;
}

.incident-side-menu-labeled-content {
  min-width: 0;

  gz-icon-label {
    pointer-events: none;
  }
}

.header,
.panel-content {
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
}

.d-none {
  display: none;
}

.panel-content {
  flex: 2;
  overflow: scroll;
  height: calc(100% - 124px);

  .accordion-slot {
    width: calc(100% - 26px);
  }

  .accordion-count {
    padding-left: calc(var(--spacer) / 2);
  }

  .accordion-title {
    text-transform: uppercase;
    font-size: var(--body-size-small);
    font-weight: 500;
  }

  .accordion-title,
  .accordion-count {
    color: var(--chart-300-icon-buttons);
    width: auto;
  }
}

gz-list-item {
  padding: 0;
  color: var(--main-titles-inputs-600);
  font-weight: 200;
  padding-left: calc(var(--spacer) * 2);
}

gz-accordion {
  padding-top: calc(var(--spacer) * 2);
  --margin--compact-accordion: 0;
}

.group-incidents {
  border-left: 1px solid var(--chart-101-pressed-dividers);
}

.single-incident,
.group-incidents {
  display: flex;
  align-items: center;

  gz-icon-label {
    width: 24px;
    padding-left: calc(var(--spacer) / 2);
  }
}

gz-labeled-content {
  --label-width-percentage: 65%;
  --value-width-percentage: 35%;
}
